// extracted by mini-css-extract-plugin
var _1 = "neH_J";
var _2 = "kkhkU";
export { _1 as "details", _2 as "detailsWrapper" }
